import UFOSegment from './segment';

export default UFOSegment;
export { UFOThirdPartySegment } from './third-party-segment';
